module.exports = __webpack_public_path__ + "static/media/sp20.9967e3de.JPG";